import { Plugin } from '@nuxt/types'
import { initializeKVS } from '@/modules/storage/storage'

export const plugin: Plugin = (): void => {
  initializeKVS(sessionStorage)
}

export default plugin
